import React from 'react';
import Link from 'shared/Link.jsx';

const Unauthorized = () => (
  <div>
    <div className="alert alert-danger">
      {
        `Sorry, but you do not have permission to view this page. If you believe this is incorrect please contact your Registration support at USBC.`
      }
    </div>
    <div className="flex center">
      <Link
        className="btn btn-primary btn-lg"
        to="">{`Go Back Home`}</Link>
    </div>
  </div>
);

export default Unauthorized;



// WEBPACK FOOTER //
// ./src/features/shared/auth/Unauthorized.jsx